/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { mFIATPInventoryAsync } from './CoreProductDataActionExtension.g';
import { IMFIATPInventoryResponse, IMFICLDeliveryScheduleParameters } from './CoreProductDataServiceEntities.g';

/**
 * GetDeliveryMessage Input Action
 */

export class GetDeliveryMessageInput implements Msdyn365.IActionInput {
    // Construct the input needed to run the action
    public input: IMFICLDeliveryScheduleParameters;
    public isCached?: boolean;
    constructor(input: IMFICLDeliveryScheduleParameters, isCached: boolean = true) {
        this.input = input;
        this.isCached = isCached;
    }

    // Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () =>
        `Get-Delivery-Message${this.input.ZipCode}-${this.input.ItemLines![0].ItemId}-${this.input.ItemLines![0].VariantRecordId}`;
    // public getCacheKey = () => 'do';
    public getCacheObjectType = () => 'GetDeliveryMessageResult';
    public dataCacheType = (): Msdyn365.CacheType => (this.isCached ? 'request' : 'none');
}

//   Create a data model here or import one to capture the response of the action

/**
 *   Use this function to create the input required to make the action call
 */
// const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     return new GetDeliveryMessageInput();
// };

/**
 *   Use this function to call your action and process the results as needed
 */
async function getDeliveryMessageAction(
    request: GetDeliveryMessageInput,
    ctx: Msdyn365.IActionContext
): Promise<IMFIATPInventoryResponse | null> {
    if (request.input) {
        try {
            const result = await mFIATPInventoryAsync({ callerContext: ctx }, request.input);
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMFIATPInventoryResponse | null>>getDeliveryMessageAction,
    //   Give your data action a unique id
    id: 'GetDeliveryMessage'
    // input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
